import { Font } from "@/src/components";
import styles from "./index.module.scss";
import PointLineTriangle1 from "@/src/components/icons/PointLineTriangle1";
import PointLineTriangle2 from "@/src/components/icons/PointLineTriangle2";
import { Headline, WordStyling } from "@/src/utils/types/landingpage";
import Button from "@/src/components/elements/Button";

export default function LandingOverview({
  headline,
  handleLogin,
  listWordStyling,
}: {
  headline: Headline[];
  handleLogin: () => void;
  listWordStyling: WordStyling[];
}) {
  return (
    <div className={styles["section-overview"]} id="landing-page-overview">
      <div className={styles["point-line-triangle-2-wrapper"]}>
        <PointLineTriangle2 />
      </div>
      <div className={styles["hero-section"]} id="overview-hero-section">
        <img
          className={styles["image-product-screenshot"]}
          src={`${process.env.NEXT_PUBLIC_IMAGES}/${headline?.find(hl => hl.nama_headline === "bribrain")?.thumbnail_headline}`}
          alt=""
          width= "100%"
          height= "200px"
        />
        <div
          className={styles["description-section"]}
          id="overview-description-section"
        >
          <Font variant="subtitle-1-medium" color="dark40" align="center" listWordStyling={listWordStyling} >
            {headline?.find(hl => hl.nama_headline === "bribrain")?.deskripsi_headline}
          </Font>
        </div>
        <Button
          size="medium"
          text="Login"
          onClick={handleLogin}
        />
      </div>
    </div>
  );
}
